
import { Skeleton } from "@/components/ui/skeleton";
import Navbar from '@/components/homepage/Navbar';
import Footer from '@/components/homepage/Footer';

const LegalSkeleton = () => {
  return (
    <div className="min-h-screen overflow-x-hidden flex flex-col bg-gradient-to-br from-gray-900 to-indigo-950 relative">
      {/* Background decorative elements */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full bg-purple-500/20 blur-3xl"></div>
      <div className="absolute bottom-1/4 right-1/3 w-64 h-64 rounded-full bg-blue-500/20 blur-3xl"></div>
      
      <Navbar />
      
      <main className="flex-grow pt-28 pb-16 relative z-10">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto glassmorphism-dark p-8 rounded-2xl">
            <Skeleton className="h-12 w-80 mb-8 bg-white/10" />
            
            <div className="space-y-8">
              <Skeleton className="h-4 w-48 bg-white/10" />
              
              {/* Multiple sections skeleton */}
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="space-y-4">
                  <Skeleton className="h-8 w-64 bg-white/10" />
                  <Skeleton className="h-4 w-full bg-white/10" />
                  <Skeleton className="h-4 w-5/6 bg-white/10" />
                  <Skeleton className="h-4 w-4/5 bg-white/10" />
                  
                  {/* List items */}
                  <div className="space-y-2 ml-5">
                    <Skeleton className="h-4 w-3/4 bg-white/10" />
                    <Skeleton className="h-4 w-2/3 bg-white/10" />
                    <Skeleton className="h-4 w-5/6 bg-white/10" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default LegalSkeleton;
